import React from 'react';
import { useExperiments } from '@wix/wix-experiments-react';
import { GlobalDesignActionLobbyItem } from '../types';
import { processStyleMetadataForLobby } from '../common/lobby/processStyleMetadataForLobby';
import { COMBINED_CORNER_PROPERTIES } from '../../../apis/services/editActionsServices/nativeActions/globalDesign/corner/constants';
import { LobbyItemLayout } from '../common/lobby/LobbyItemLayout';
import BorderRadiusPreview from '../controls/GroupPreview/BorderRadiusPreview/BorderRadiusPreview';
import { useGroupsPreviewPS } from '../common/lobby/useGroupsPreviewPS';
import { GD_WDS_EXPERIMENT } from '../experiments';

const CORNER_PROPERTY_CONFIG = [
  {
    resultKey: 'borderRadius',
    mixedKey: 'isMixed',
    atomicKeys: COMBINED_CORNER_PROPERTIES,
  },
] as const;

const CornerLobbyItem: GlobalDesignActionLobbyItem = (props) => {
  const { experiments } = useExperiments({ readOnly: true });
  const isWDS = experiments.enabled(GD_WDS_EXPERIMENT);

  // Always call hook (React rules)
  const renderGroupPreviewPS = useGroupsPreviewPS(
    props.actionName,
    props.group,
  );

  const processedStyleMetadata = processStyleMetadataForLobby(
    props.group.engine,
    CORNER_PROPERTY_CONFIG,
  );

  const value = processedStyleMetadata.borderRadius[0] || '0px';
  const formattedValue = value.replace('spx', 'px');

  if (!isWDS) {
    return (
      renderGroupPreviewPS({
        value,
        isMixed: processedStyleMetadata.isMixed,
        emptyPreviewLabel: formattedValue,
        onClick: props.onSelect,
      }) ?? null
    );
  }

  return (
    <LobbyItemLayout
      actionName={props.actionName}
      group={props.group}
      onSelect={props.onSelect}
    >
      <BorderRadiusPreview
        value={formattedValue}
        isMixed={processedStyleMetadata.isMixed}
        emptyPreviewLabel={
          props.group.displayName.group || props.group.displayName.component
        }
      />
    </LobbyItemLayout>
  );
};

export default CornerLobbyItem;
